import { render } from "./VirtualNumbersPackages.vue?vue&type=template&id=9df0de44"
import script from "./VirtualNumbersPackages.vue?vue&type=script&lang=js"
export * from "./VirtualNumbersPackages.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Bohdan\\telesim_test\\telesim-admin-panel\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__